import { computed, ref } from '@vue/composition-api'

function useFilter(config) {
  if (!config) return
  const defaultMap = ref({})
  const listMap = ref({})
  const selected = ref({})

  for (const filter of config) {
    defaultMap.value[filter.id] = false
    listMap.value[filter.id] = filter.list
    selected.value[filter.id] = []

    if (filter.initial) {
      defaultMap.value[filter.id] = true

      for (const id of filter.initial) {
        const find = listMap.value[filter.id].find((v) => v.id === id)
        if (!find) continue

        selected.value[filter.id].push(find)
      }
    } else {
      selected.value[filter.id] = listMap.value[filter.id]
    }
  }

  const isDefault = computed(
    () => !Object.values(defaultMap.value).some((v) => v)
  )

  const selectCounter = computed(() =>
    Object.values(defaultMap.value).reduce((p, v) => (v ? ++p : p), 0)
  )

  return {
    list: listMap.value,
    selected: selected.value,
    isDefault: isDefault.value,
    defaultState: defaultMap.value,
    selectCounter: selectCounter.value
  }
}

export default useFilter
